import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import EmailVerificationRedirector from './Components/EmailVerificationRedirector';
import ScrollToTop from './Components/ScrollToTop';

import Header from './Components/Header';
import Footer from './Components/Footer';

import Home from './Pages/Home';
import About from './Pages/About';
import AdvancedStats from './Pages/AdvancedStats';
import OrderTracking from './Pages/OrderTracking';
import Contact from './Pages/Contact';
import Cart from './Pages/Cart';
import Payment from './Pages/Payment';
import UserProfile from './Pages/UserProfile';
import Signup from './Pages/Signup';
import Login from './Pages/Login';
import AdminPage from './Pages/AdminPage';
import Orders from './Pages/Orders';
import AdminProducts from './Pages/AdminProducts';
import AdminUsers from './Pages/AdminUsers';
import AdminSettings from './Pages/AdminSettings';
import InstallPrompt from './Components/InstallPrompt';
import ProductDetail from './Components/ProductDetail';
import VerifyPhone from './Pages/VerifyPhone';
import ProductImages from './Pages/ProductImages';
import AddStore from './Pages/AddStore';
import StoreDetail from './Components/StoreDetail';

import SearchResults from './Pages/SearchResults';
import SearchPage from './Pages/SearchPage';
import ShopProducts from './Components/ShopProducts';

function AppWrapper() {
  const location = useLocation();

  // Hide Header and Footer only for admin routes
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      <EmailVerificationRedirector />

      {!isAdminRoute && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/UserProfile" element={<UserProfile />} />
        <Route path="/OrderTracking" element={<OrderTracking />} />
        <Route path="/stats" element={<AdvancedStats />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-phone" element={<VerifyPhone />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/searchpage" element={<SearchPage />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/shop-products/:storeId" element={<ShopProducts />} />
        <Route path="/store/:id" element={<StoreDetail />} />

        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/orders" element={<Orders />} />
        <Route path="/admin/products" element={<AdminProducts />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/AddStore" element={<AddStore />} />
        <Route path="/admin/ProductImages" element={<ProductImages />} />
      </Routes>

      {!isAdminRoute && <Footer />}
      <InstallPrompt />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
